<div class="column-config-editor">
  <h2>{{ titleLabel }}</h2>
  <div class="columns-container">
    <!-- Dummy column for Source Terms (left) -->
    <mat-card class="column-box dummy-column source-column">
      <mat-card-header>
        <h6>{{ sourceTermsLabel }}</h6>
      </mat-card-header>
      <mat-card-content>
        <div class="dummy-description">
          {{ sourceTermsDescription }}
        </div>
      </mat-card-content>
    </mat-card>

    <div class="column-boxes" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
      @for (row of columnRows; track trackByRowId($index, row)) {
        <mat-card cdkDrag class="column-box">
          <mat-card-header>
            <h6>{{ columnLabel }} {{ columnRows.indexOf(row) + 1 }}</h6>
            <mat-icon (click)="removeColumn(columnRows.indexOf(row))"
              [attr.aria-label]="removeLabel" class="delete-button">close
            </mat-icon>
          </mat-card-header>
          <mat-card-content>
            <div class="label-container" [matTooltip]="columnLabelTooltip" matTooltipPosition="before">
              @if (!row.editingLabel) {
                <span (click)="startEditLabel(row)" class="label-text">{{ row.label }}</span>
              }
              @if (!row.editingLabel) {
                <mat-icon (click)="startEditLabel(row)" class="edit-icon">edit</mat-icon>
              }
              @if (row.editingLabel) {
                <mat-form-field class="label-input">
                  <input matInput [(ngModel)]="row.label" (blur)="stopEditLabel(row)" (keyup.enter)="stopEditLabel(row)">
                </mat-form-field>
              }
            </div>
            <mat-form-field class="language-select" [matTooltip]="columnLanguageTooltip" matTooltipPosition="before">
              <mat-label>{{ languageLabel }}</mat-label>
              <mat-select [(ngModel)]="row.selectedLang" (selectionChange)="onLanguageChange(row)">
                <mat-option [value]="'none'">{{ noneConceptLevelLabel }}</mat-option>
                @for (lang of languages; track lang.code) {
                  <mat-option [value]="lang.code">
                    {{ lang.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="field-select" [matTooltip]="columnFieldTooltip" matTooltipPosition="before">
              <mat-label>{{ fieldLabel }}</mat-label>
              <mat-select [(ngModel)]="row.selectedRow" (selectionChange)="onFieldChange(row)">
                <mat-select-trigger>
                  <span>{{ row.selectedRow?.label }}</span>
                  @if (isMultipleDicts(row.selectedRow)) {
                    <span
                      class="dict-count">&nbsp;({{ row.selectedRow?.dictionaries?.length }} {{ dictsLabel }})</span>
                  }
                </mat-select-trigger>
                @if (row.lang === undefined) {
                  <mat-optgroup [label]="conceptLevelLabel">
                    @for (field of conceptFields; track field.fieldKey.jsonField) {
                      <mat-option [value]="field">
                        <span>{{ field.label }}</span>
                        @if (isMultipleDicts(field)) {
                          <span class="dict-count">&nbsp;({{ field.dictionaries.length }}
                            {{ dictsLabel }})</span>
                        }
                      </mat-option>
                    }
                  </mat-optgroup>
                }
                @if (row.lang !== undefined) {
                  <mat-optgroup [label]="termLevelLabel">
                    <mat-option [value]="termNameField">{{ termNameLabel }}</mat-option>
                    @for (field of termFields; track field.fieldKey.jsonField) {
                      <mat-option [value]="field">
                        <span>{{ field.label }}</span>
                        @if (isMultipleDicts(field)) {
                          <span class="dict-count">&nbsp;({{ field.dictionaries.length }}
                            {{ dictsLabel }})</span>
                        }
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      }
    </div>
    <div class="add-column-container">
      <button mat-mini-fab color="primary" (click)="addColumn()" [attr.aria-label]="addColumnLabel">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <!-- Dummy column for Target Terms (right) -->
    <mat-card class="column-box dummy-column target-column">
      <mat-card-header>
        <h6>{{ targetTermsLabel }}</h6>
      </mat-card-header>
      <mat-card-content>
        <div class="dummy-description">
          {{ targetTermsDescription }}
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  @if (errorMessage) {
    <div class="error-message">{{ errorMessage }}</div>
  }
  <div class="button-container">
    <button mat-raised-button color="primary" (click)="saveChanges()">{{ saveLabel }}</button>
    <button mat-raised-button (click)="cancelChanges()">{{ cancelLabel }}</button>
  </div>
</div>
